import {ApiResponse} from '@shared/helpers/api'

import {GwErrorName} from '@web/core/constants'

export function getErrorObjectFromUnknown<T extends Error = Error>(param: unknown): Maybe<T> {
    const paramIsErrorObject = param && typeof param === 'object'
    if (paramIsErrorObject && 'name' in param && 'message' in param) {
        return param as T
    }

    return null
}

export type GwError<T = unknown> = Pick<ApiResponse<ApigwResponseBase<T>>, 'data' | 'status'>

export const getGwErrorMessage = <T>(message: string): Maybe<GwError<T>> => {
    try {
        return JSON.parse(message) as GwError<T>
    } catch {
        return null
    }
}

/**
 * status 200이지만 BFF에서 createErrorResponse로 생성하여 리턴한 에러응답 여부
 */
export const isGwErrorResponse = (error: unknown): error is {name: string; message: string} => {
    const errorObject = getErrorObjectFromUnknown(error)
    if (errorObject) {
        return errorObject.name === GwErrorName
    }
    return false
}

export const getErrorResponse = <T>(error: unknown): Maybe<T> => {
    try {
        const errorObject = getErrorObjectFromUnknown(error)
        if (errorObject) {
            const message = getGwErrorMessage(errorObject.message)
            return (message?.data?.result as Maybe<T>) ?? null
        }
        return null
    } catch {
        return null
    }
}

/**
 * api error body 를 공통포멧으로 처리하기위한 함수
 **/
export const isErrorPayload = (
    payload: unknown,
): payload is {
    code: string
    fallbackMessage: string
} => {
    return !!(payload && payload instanceof Object && 'code' in payload && 'fallbackMessage' in payload)
}

export const isRejectedWithValue = (error: unknown): error is {code: string; message?: string} => {
    return !!(error && error instanceof Object && 'code' in error)
}

export const isSerializedError = (error: unknown): error is {message: string} => {
    return !!(error && typeof error === 'object' && 'message' in error && typeof error.message === 'string')
}
